/* This is the EMIS Pre student and ethnic components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <table style="width: 709px; height: 77px" border="1px;" cellspacing="0px;">
      <tbody>
        <tr style="height: 29px">
          <td
            style="
              width: 100px;
              height: 54px;
              text-align: center;
              vertical-align: middle;
            "
            rowspan="2"
          >
            <span v-html="ctitle"></span>
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតទាប
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតមធ្យម
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់កម្រិតខ្ពស់
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            ថ្នាក់ចម្រុះ
          </td>
          <td
            style="
              width: 60px;
              height: 29px;
              text-align: center;
              vertical-align: middle;
            "
            colspan="2"
          >
            សរុប
          </td>
        </tr>
        <tr style="height: 25px">
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
          <td class="td-white">សរុប</td>
          <td class="td-white">ស្រី</td>
        </tr>
        <!-- Data Row -->
        <tr
          v-for="(value, row) in preAge.length"
          v-if="row >= age_cont"
          :key="row"
          style="height: 25px"
        >
          <td
            style="
              width: 100px;
              height: 25px;
              text-align: center;
              vertical-align: middle;
            "
          >
            {{ preAge[row] }}
          </td>
          <td :class="[OnOff[row][0] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[0]"
              :disabled="!OnOff[row][0]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][1] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[1]"
              :disabled="!OnOff[row][1]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][2] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[2]"
              :disabled="!OnOff[row][2]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][3] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[3]"
              :disabled="!OnOff[row][3]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][4] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[4]"
              :disabled="!OnOff[row][4]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][5] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[5]"
              :disabled="!OnOff[row][5]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][6] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[6]"
              :disabled="!OnOff[row][6]"
              class="number"
            />
          </td>
          <td :class="[OnOff[row][7] ? 'td-white' : 'td-light']">
            <numberinput
              v-model="data[row].dt[7]"
              :disabled="!OnOff[row][7]"
              class="number"
            />
          </td>
          <td class="td-white">
            <strong>{{ col1[row] | blank }}</strong>
          </td>
          <td class="td-white">
            <strong>{{ col2[row] | blank }}</strong>
          </td>
        </tr>
        <!-- Total Row -->
        <tr style="height: 25px">
          <td
            style="
              width: 100px;
              height: 25px;
              text-align: center;
              vertical-align: middle;
            "
          >
            សរុប
          </td>
          <td
            v-for="(value, col) in totalRow.length"
            :key="col"
            class="td-white"
          >
            <strong>{{ totalRow[col] | blank }}</strong>
          </td>
          <td class="td-white">
            <strong>{{ tCol1 | blank }}</strong>
          </td>
          <td class="td-white">
            <strong>{{ tCol2 | blank }}</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { preAge, preStudentOnOff } from "@/utils/ascf/preConfig.js";
export default {
  props: ["data", "title", "ctitle", "age_cont"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      preAge: preAge,
      OnOff: preStudentOnOff,
    };
  },
  computed: {
    /* col1 and col2 are compute function in each row by age and total/gender */
    col1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    col2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    /* totalRow are the summing of each column total and female */
    totalRow: function () {
      let result;
      let d = this.data;
      let ldata = this.data.length - 1;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (ind < ldata) {
            // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      // update the total row array in JSON
      d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i];
      });
      return result;
    },
    /* tCol1, tCol2 are the total of total row and column */
    tCol1: function () {
      return (
        this.totalRow[0] +
        this.totalRow[2] +
        this.totalRow[4] +
        this.totalRow[6]
      );
    },
    tCol2: function () {
      return (
        this.totalRow[1] +
        this.totalRow[3] +
        this.totalRow[5] +
        this.totalRow[7]
      );
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
</style>